import { Injectable } from "@angular/core";
import { Router, CanActivate, ActivatedRouteSnapshot } from "@angular/router";
import { AppserviceService } from "../_service/appservice/appservice.service";


@Injectable({
providedIn: "root"
})
export class CanActivateGuard implements CanActivate {


permit: any = null;  // must be null.... until set also triggered by menu
goToUrl: string;
isLogout: number = 0;



constructor(public router: Router, public appService: AppserviceService) {
    
}


navStats(){
console.log("ROUTE STATS" + this.router.url + ' <> '+ this.goToUrl + ' permit? ' + this.permit);
}




// PROMISE
async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    
console.log(this.router.url, this.goToUrl = '/'+ route.parent.routeConfig.path , this.permit);

//console.log(this.router.url,this.goToUrl)
//NO GUARD ON ZOOM




//1. splash
if(this.router.url === '/' && this.goToUrl === "/"){    
console.log('allowed root & permit: ' + this.permit);
this.permit = 0;
return true; 
} 


//2. front
if(!this.permit && this.router.url === '/' && this.goToUrl === "/front"){    
console.log('initial external & permit: ' + this.permit);
return true; 
} 



//3. navigate
if(this.permit > 0 ){
//console.log('allowed activate bypass');  
this.permit = 0;
return true; 
}


//3. BOUNCE BACK
this.router.navigate([this.router.url],{skipLocationChange: true});  
history.forward();
console.log("reject can activate");
return false;


}  // end observable function



} // end of class